var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_254_1120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_254_1120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.67952 12.541C3.38863 12.541 3.14013 12.438 2.93402 12.232C2.72801 12.0259 2.625 11.7774 2.625 11.4865V6.0122C2.625 5.72131 2.72801 5.47281 2.93402 5.2667C3.14013 5.06069 3.38863 4.95768 3.67952 4.95768H4.375V3.79102C4.375 3.06263 4.6304 2.44303 5.14121 1.93222C5.65201 1.42142 6.27161 1.16602 7 1.16602C7.72839 1.16602 8.34799 1.42142 8.85879 1.93222C9.3696 2.44303 9.625 3.06263 9.625 3.79102V4.95768H10.3205C10.6114 4.95768 10.8599 5.06069 11.066 5.2667C11.272 5.47281 11.375 5.72131 11.375 6.0122V11.4865C11.375 11.7774 11.272 12.0259 11.066 12.232C10.8599 12.438 10.6114 12.541 10.3205 12.541H3.67952ZM3.67952 11.666H10.3205C10.3729 11.666 10.4159 11.6492 10.4495 11.6156C10.4832 11.5819 10.5 11.5389 10.5 11.4865V6.0122C10.5 5.9598 10.4832 5.91678 10.4495 5.88314C10.4159 5.8495 10.3729 5.83268 10.3205 5.83268H3.67952C3.62712 5.83268 3.5841 5.8495 3.55046 5.88314C3.51682 5.91678 3.5 5.9598 3.5 6.0122V11.4865C3.5 11.5389 3.51682 11.5819 3.55046 11.6156C3.5841 11.6492 3.62712 11.666 3.67952 11.666ZM7 9.77018C7.2834 9.77018 7.52442 9.67092 7.72304 9.47239C7.92157 9.27376 8.02083 9.03275 8.02083 8.74935C8.02083 8.46595 7.92157 8.22493 7.72304 8.02631C7.52442 7.82778 7.2834 7.72852 7 7.72852C6.7166 7.72852 6.47558 7.82778 6.27696 8.02631C6.07843 8.22493 5.97917 8.46595 5.97917 8.74935C5.97917 9.03275 6.07843 9.27376 6.27696 9.47239C6.47558 9.67092 6.7166 9.77018 7 9.77018ZM5.25 4.95768H8.75V3.79102C8.75 3.3049 8.57986 2.89171 8.23958 2.55143C7.89931 2.21115 7.48611 2.04102 7 2.04102C6.51389 2.04102 6.10069 2.21115 5.76042 2.55143C5.42014 2.89171 5.25 3.3049 5.25 3.79102V4.95768Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.cdb5108fef6cc3700bb69773ca2fa83f.svg";
export { ForwardRef as ReactComponent };